export default __webpack_public_path__ + "static/exotic_3-68689c216982e2d9bc3532be8754ce1b.webp";